import { formValueSelector, getFormValues } from 'redux-form'

const bookFormSelector = formValueSelector('book')
const bookFormDataSelector = state => getFormValues('book')(state)

const fromSelector = state => bookFormSelector(state, 'from')
const toSelector = state => bookFormSelector(state, 'to')
const priceSelector = state => bookFormSelector(state, 'price')
const limitSelector = state => bookFormSelector(state, 'limit')
const lastnameSelector = state => bookFormSelector(state, 'surname')
const firstnameSelector = state => bookFormSelector(state, 'name')
const phoneSelector = state => bookFormSelector(state, 'phone')
const addPaxSelector = state => bookFormSelector(state, 'addPax')
const noteSelector = state => bookFormSelector(state, 'note')
const systemSelector = state => bookFormSelector(state, 'system')
const placeSelector = state => bookFormSelector(state, 'place')

export {
  lastnameSelector,
  firstnameSelector,
  phoneSelector,
  addPaxSelector,
  noteSelector,
  systemSelector,
  limitSelector,
  fromSelector,
  toSelector,
  priceSelector,
  bookFormDataSelector,
  placeSelector
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/BookFormSelectors.js